/**
 * ACL 权限代码常量（与 nest-api resource:action 格式对齐）
 */

/** 超级管理员通配权限 */
export const ALL_MANAGE_PERMISSION = 'all:manage';

/** 资产模块权限 */
export const ASSET_PERMISSION = {
  LIST: 'asset:list',
  READ: 'asset:read',
  CREATE: 'asset:create',
  UPDATE: 'asset:update',
  DELETE: 'asset:delete',
  IMPORT: 'asset:import',
  TRANSFER: 'asset:transfer',
} as const;

/** 订单模块权限 */
export const ORDER_PERMISSION = {
  READ: 'order:read', // 查看订单
  CREATE: 'order:create', // 创建订单
  UPDATE: 'order:update', // 更新订单
  DELETE: 'order:delete', // 删除订单
  BIND_ASSET: 'order:bind_asset', // 绑定资产
  UNBIND_ASSET: 'order:unbind_asset', // 解绑资产
  UPDATE_DEPOSIT: 'order:update_deposit', // 更新押金
  DEDUCT_DEPOSIT: 'order:deduct_deposit', // 扣除押金
  DEPOSIT: 'order:deposit', // 押金操作
  OFFLINE_PAYMENT: 'order:offline_payment', // 线下入账
  OFFLINE_REFUND: 'order:offline_refund', // 线下退款
  ONLINE_PAYMENT: 'order:online_payment', // 在线扣款
} as const;

/** 财务模块权限 */
export const FINANCE_PERMISSION = {
  LIST: 'finance:list',
  READ: 'finance:read',
  CREATE: 'finance:create',
  UPDATE: 'finance:update',
  DELETE: 'finance:delete',
} as const;
